import { I18nRouteCache } from '@bcf-v2/routes/i18n-route-cache';

// impure
export const appRoutesI18nCache: I18nRouteCache = new I18nRouteCache();

export type TranslationConfig = {
  translateForLang?: boolean;
};
